import React, { useState } from 'react';
import OverlayWindow from './OverlayWindow';

const OperationFailureDialog = ({ isOpen, onClose, failedTaskNames, operationName }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  if (!isOpen) return null;

  const handleCopyFailedTasks = async () => {
    if (!failedTaskNames || failedTaskNames.length === 0) return;
    
    const taskList = failedTaskNames.map((task, index) => `${index + 1}. ${task}`).join('\n');
    const copyText = `Fehlgeschlagene Aufgaben für "${operationName}":\n\n${taskList}`;
    
    try {
      await navigator.clipboard.writeText(copyText);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <OverlayWindow
      isOpen={isOpen}
      onClose={onClose}
      name="Operation failure"
      closeOnBackdrop={true}
      panelClassName="relative w-full max-w-2xl max-h-[90dvh] flex flex-col bg-white border-2 border-[var(--ink-900)]"
    >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-[var(--rule)] pr-10">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-[var(--cream)] flex items-center justify-center">
              <span className="text-[var(--error)] text-xl font-bold">!</span>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-[var(--ink-900)]">Operation fehlgeschlagen</h2>
              <p className="text-sm text-[var(--ink-700)]">{operationName}</p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-hidden flex flex-col">
          <div className="p-6 pb-4">
            <div className="flex items-center justify-between mb-4">
              <p className="text-[var(--ink-700)]">
                Die folgenden Aufgaben sind fehlgeschlagen:
              </p>
              {failedTaskNames && failedTaskNames.length > 0 && (
                <button
                  onClick={handleCopyFailedTasks}
                  className={`flex items-center space-x-2 px-3 py-1.5 text-xs font-medium transition-colors ${
                    copySuccess
                      ? 'bg-[var(--cream)] text-[var(--success)] border border-[var(--success)]'
                      : 'bg-white text-[var(--ink-700)] border border-[var(--rule)] hover:bg-[var(--cream)]'
                  }`}
                >
                  {copySuccess ? (
                    <>
                      <span>✓</span>
                      <span>Kopiert!</span>
                    </>
                  ) : (
                    <>
                      <span aria-hidden="true">⧉</span>
                      <span>Kopieren</span>
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
          
          {/* Scrollable list of failed tasks */}
          <div className="flex-1 overflow-y-auto px-6 pb-6">
            <div className="space-y-2 max-h-96">
              {failedTaskNames && failedTaskNames.length > 0 ? (
                failedTaskNames.map((taskName, index) => (
                  <div
                    key={index}
                    className="flex items-start space-x-3 p-3 bg-[var(--cream)] border border-[var(--error)]"
                  >
                    <div className="flex-shrink-0 w-5 h-5 bg-[var(--cream)] flex items-center justify-center mt-0.5">
                      <span className="text-[var(--error)] text-xs">✕</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-sm text-[var(--ink-900)] font-medium">{taskName}</p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-8 text-[var(--ink-500)]">
                  <div className="w-16 h-16 bg-[var(--cream)] flex items-center justify-center mx-auto mb-4">
                    <span className="text-[var(--error)] text-2xl font-bold">!</span>
                  </div>
                  <p className="text-[var(--ink-700)] font-medium mb-2">Operation fehlgeschlagen</p>
                  <p className="text-sm text-[var(--ink-500)]">
                    Die Operation ist fehlgeschlagen, aber Details zu den Aufgaben sind nicht verfügbar.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-6 border-t border-[var(--rule)]">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[var(--ink-900)] text-white hover:opacity-80 transition-colors"
          >
            Schließen
          </button>
        </div>
    </OverlayWindow>
  );
};

export default OperationFailureDialog;
